import { Component,ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-uk-my-profile',
    templateUrl: './uk-my-profile.component.html',
    styleUrls: ['./uk-my-profile.component.scss'],
    standalone: false
})
export class UkMyProfileComponent {

}
